import { render, staticRenderFns } from "./StorelessSuggestion.vue?vue&type=template&id=59a18663&scoped=true&"
import script from "./StorelessSuggestion.vue?vue&type=script&lang=js&"
export * from "./StorelessSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./StorelessSuggestion.vue?vue&type=style&index=0&id=59a18663&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a18663",
  null
  
)

export default component.exports